<script setup lang="ts">
import type { ActiveFilterChip } from '~/utils/filter/chips'

const openFilter = defineModel('openFilter', { default: false })

const {
  searchKeyword,
  totalLaws,
  totalFilteredLaws,
  hasFilters,
  showOnlyFavorites,
  sortFilter,
  selectedLegalArea,
  selectedAuthor,
  hasLawComment,
  toggleHasLawComment,
} = useLawFilters()

const { loggedIn } = useUserSession()

const count = computed(() =>
  hasFilters.value ? `${totalFilteredLaws.value} treff` : `${totalLaws.value} lover`,
)

const chips = computed<ActiveFilterChip[]>(() => [
  ...(hasLawComment.value
    ? [{ key: 'lovkommentar', label: 'Med lovkommentar', remove: toggleHasLawComment }]
    : []),
  ...selectedLegalArea.value.map(option => ({
    key: `area:${option.value}`,
    label: option.label,
    remove: () => {
      selectedLegalArea.value = selectedLegalArea.value.filter(o => o.value !== option.value)
    },
  })),
  ...selectedAuthor.value.map(option => ({
    key: `author:${option.value}`,
    label: option.label,
    remove: () => {
      selectedAuthor.value = selectedAuthor.value.filter(o => o.value !== option.value)
    },
  })),
  ...(loggedIn.value && showOnlyFavorites.value
    ? [{ key: 'favorites', label: 'Favoritter', remove: () => { showOnlyFavorites.value = false } }]
    : []),
])
</script>

<template>
  <FilterListHeader
    v-model:search="searchKeyword"
    v-model:open-filter="openFilter"
    breakpoint="md"
    :count="count"
    search-id="law-search-compact"
    search-label="Filtrer på lov eller rettsområde"
    search-placeholder="Finn lov"
    :chips="chips"
  >
    <template #actions>
      <FilterFavoritesChip v-model="showOnlyFavorites" breakpoint="xl" />
      <FilterSortSelect id="sort-laws" v-model="sortFilter" :options="LAW_SORTING_OPTIONS" />
    </template>
    <LawMobileFilters v-model:open-filter="openFilter" />
  </FilterListHeader>
</template>